import React, { FC } from "react";
import type { PlatformRegulationsProps } from "@/types";
import { Image } from "../image";
import { TextCols } from "../text-cols";

export const PlatformRegulations: FC<PlatformRegulationsProps> = ({
  text,
  image,
}) => {
  return (
    <section className="platformRegulations">
      <div className="wrapper">
        <TextCols maxTitleWidth={676} size="md" content={text} />
      </div>
      <div className="wrapper wrapper_lg">
        <div className="platformRegulations--image-wrapper">
          {image?.file && (
            <Image
              className="platformRegulations--image"
              src={image as any}
              alt={image.title}
            />
          )}
        </div>
      </div>
    </section>
  );
};
